import React from 'react';
import { useField } from 'react-final-form';
import { required, combineValidators, validSSN } from '../../../services/validators.service';
import { useTranslation } from 'react-i18next';
import FormField from '../../FormField';
import { Input } from '@folksam/ui-next/components';
function PersonNumber({ label, ...props }) {
    const { t } = useTranslation();

    // Define validators to match old angular validators, with matching error text from commondata translations
    const validators = combineValidators([
        required(t('empty_mandatory_error')),
        validSSN(t('personnumber_validation_txt'))
    ]);
    const { input, meta } = useField(props.name, { validate: validators });

    return (
        <FormField
            label={label}
            meta={meta}
            id={props.fieldId}
            tooltipText={props.infoButton}
            component={Input}
            labelExample={'(10 siffror)'}
            inputProps={{
                ...props,
                maxlength: '13',
                type: `tel`,
                className: `sessioncamexclude`,
                placeholder: props.placeholder,
                id: props.fieldId,
                ...input
            }}
        />
    );
}
export default PersonNumber;
